/* eslint react/jsx-pascal-case: 0 */
import React, { useState } from 'react'
import { StyledPopupButton, StyledPopupContent, StyledPopups, StyledPopupWrapper, StyledPopupContentHeader } from './Popup.styled.js'
import { FormattedHTMLMessage } from 'react-intl'
import SVG from 'react-inlinesvg'
import useKeyDown from '../../utils/useKeyDown'
import { StyledBurger } from '../Burger/Burger.styled'
import Video from '../Video'
import Button from '../Button/Button'
const Popup = ({ icon = 'open_book', labelID = 'defaultLabel', popupHeaderId = 'popupheader', img, textID, videoSrc, intlKey, component, props, position, width }) => {
  const [isPoppedUp, setIsPoppedUp] = useState(false)
  const openPopup = () => {
    setIsPoppedUp(true)
  }

  const closePopup = () => {
    const videoRef = document.getElementById('video')
    if (videoRef) { videoRef.pause() }
    setIsPoppedUp(false)
  }

  useKeyDown(27, () => setIsPoppedUp(false))
  return (
    <StyledPopupWrapper>
      <StyledPopupButton isPoppedUp={isPoppedUp} onClick={() => openPopup()}>
        <SVG src={`icons/${icon}.svg`} />
        <FormattedHTMLMessage id={intlKey + labelID} />
      </StyledPopupButton>
      <StyledPopupContent width={width} position={position} isPoppedUp={isPoppedUp} className={isPoppedUp ? 'open' : 'closed'}>
        <StyledPopupContentHeader>
          <FormattedHTMLMessage id={intlKey + popupHeaderId} />
          <StyledBurger isOpen onClick={() => setIsPoppedUp(false)}>
            <div />
            <div />
            <div />
          </StyledBurger>
        </StyledPopupContentHeader>
        {img && <img src={`image/popup/${img}`} alt='ludvig' />}
        {textID && <FormattedHTMLMessage id={intlKey + textID} />}
        {videoSrc && <Video videoSrc={videoSrc} />}>
        <Button classes='white' alignSelf='center' text='closePopupLabel' handleClick={() => closePopup()} />
      </StyledPopupContent>
    </StyledPopupWrapper>
  )
}

const Popups = ({ popups, intlKey }) => {
  let positionProps = ['left', 'center', 'right']
  switch (popups.length) {
    case 1: {
      positionProps = [positionProps[1]]
      break
    }
    case 2: {
      positionProps = [positionProps[0], positionProps[2]]
      break
    }
    default: {
      break
    }
  }
  return (
    <StyledPopups>
      {popups.map((popupItem, indx) => (<Popup key={popupItem.label + popupItem.img} {...popupItem} intlKey={intlKey} position={positionProps[indx]} />)
      )}
    </StyledPopups>
  )
}

export default Popups
